module.exports = __webpack_public_path__ + "static/media/compound.ba45efc6.svg";